import { getCodeDictionaryList } from '../apis/api_common';

const state = {
    items:{},
    SIGUNGU_CODE: [
        { id: '11', name:'서울'},	//서울특별시
        { id: '26', name:'부산'},	//부산광역시
        { id: '27', name:'대구'},	//대구광역시
        { id: '28', name:'인천'},	//인천광역시
        { id: '29', name:'광주'},	//광주광역시
        { id: '30', name:'대전'},	//대전광역시
        { id: '31', name:'울산'},	//울산광역시
        { id: '36', name:'세종'},	//세종특별자치시
        { id: '41', name:'경기'},	//경기도
        { id: '42', name:'강원'},	//강원도
        { id: '43', name:'충북'},	//충청북도
        { id: '44', name:'충남'},	//충청남도
        { id: '45', name:'전북'},	//전라북도
        { id: '46', name:'전남'},	//전라남도
        { id: '47', name:'경북'},	//경상북도
        { id: '48', name:'경남'},	//경상남도
        { id: '50', name:'제주도'},	//제주도
    ]
};

const getters = {};

const mutations = {
    SET_CODE_DICTIONARY(state, payload) {
        /*
        TABLE_TYPE("0100"),
        AUTHORIZE("0200"),
        STATUS("0300"),
        BOOKING_STATUS("0400"),
        BOOKING_TYPE("0500"),
        BOOKING_CHOICE("0600"),
        REVIEW_DTYPE("0700"),
        REVIEW_SCORE("0800"),
        REVIEW_SC_DETAIL_SCORE("0900"),
        REVIEW_SHOP_DETAIL_SCORE("1000"),
        REVIEW_TRIM_DETAIL_SCORE("1100"),
        SHOP_BUSINESS("1200"),
        TRIM_FUEL("1300"),
        TRIM_FUEL_ECONOMY("1400"),
        TRIM_BODY_STYLE("1500"),
        TRIM_DISPLACEMENT("1600"),
        BANNER_DTYPE("1700"),
        BOARD_DTYPE("1800"),
        FAQ_DTYPE("1900"),
        FAQ_TYPE_CUSTOMER("2000"),
        FAQ_TYPE_ADMIN("2100"),
        FILE_TYPE("2200");
        */
        state.items = payload;
    }
};

const actions = {
    async GET_CODE_DICTIONARY_LIST(context) {
        try {
            const response = await getCodeDictionaryList();
            context.commit('SET_CODE_DICTIONARY', response.data.data)
        } catch (e) {
            return Promise.reject(e);
        }
    },
};

export default {mutations, state, actions, getters};